

















































import { Component, Vue } from 'vue-property-decorator'
import JSZip from 'jszip'
import FilterBarReports from '@/components/reports/FilterBarReports.vue';
import AppContainerBase from '@/components/util/AppContainerBase.vue';
import { AxiosResponse } from 'axios';
import { dashboard } from '@/utils/Dashboard';

@Component({
  name: 'MainDashboards',
  components: {
    AppContainerBase,
    FilterBarReports
  }
})
export default class MainDashboards extends Vue {
  public selectedDate = ''
  public menu = false
  public loading = false
  public tab = 0
  public htmlTabs: Array<{ name: string; blobUrl: string }> = []

  async generarReporte() {
    if (!this.selectedDate) {
      alert('Selecciona una fecha')
      return
    }

    this.loading = true
    try {
      const blob = await dashboard.downloadZip('/informe_multicob_enviar/generar_reporte_analitica', {
        fecha_final: this.selectedDate
      });

      const zip = await JSZip.loadAsync(blob)
      const htmlFiles = Object.keys(zip.files).filter((filename) => filename.endsWith('.html'))

      const tabs = []
      for (let i = 0; i < htmlFiles.length; i++) {
        const file = zip.files[htmlFiles[i]]
        const textContent = await file.async('text')
        const blob_ = new Blob([textContent], { type: 'text/html' })
        const blobUrl = URL.createObjectURL(blob_)
        tabs.push({
          name: `Reporte ${i + 1}`,
          blobUrl: blobUrl,
        })
      }

      this.htmlTabs = tabs
      this.tab = 0
    } catch (err) {
      console.error('Error al generar reporte:', err)
    } finally {
      this.loading = false
    }
  }
}
